import React, { useState } from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import {
  useAddLocationMutation,
  useUpdateLocationMutation,
} from './locationApiSlice';
import Notification from '../../components/common/Notification';
import { useCountryQuery } from '../../features/country/countryApiSlice';
import { toast } from 'sonner';

const AddLocation = ({ data, isEdit, onClose }) => {
  const [addLocation] = useAddLocationMutation();
  const [updateLocation, { isLoading }] = useUpdateLocationMutation();
  const [errMsg, setErrMsg] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const {
    data: countrys,
    error: countryError,
    isLoading: countryIsLoading,
    isFetching: countryIsFetching,
    isSuccess: countryIsSuccess,
  } = useCountryQuery();
  // alert(data.name, data.description);

  const initialValues = {
    id: data?.id || '',
    name: data?.name || '',
    country_id: data?.country_id || '',
    // description: data?.desc || '',
  };
  const validationSchema = yup.object({
    name: yup.string().required('Please enter Designation name'),
    country_id: yup.string().required('Please select country'),
    // description: yup.string().required('Please enter description'),
  });
  const onSubmit = async (validationSchema) => {
    try {
      if (isEdit) {
        const accountData = await updateLocation(validationSchema).unwrap();
        toast.success('Location edited');
      } else {
        const accountData = await addLocation(validationSchema).unwrap();
        toast.success('Location added');
        formik.values.name = '';
        formik.values.country_id = '';
        // formik.values.description = '';
      }
      onClose();
    } catch (error) {}
  };
  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  });
  return (
    <>
      <Notification isShow={showNotification} />

      <form
        onSubmit={formik.handleSubmit}
        className="flex flex-col justify-between"
      >
        <div className="space-y-1">
          <h5 className="mb-3 text-sm font-normal tracking-tight text-gray-900">
            Location Name *
          </h5>

          <input
            type="text"
            name="name"
            id="name"
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.name}
          />
          {formik.touched.name && formik.errors.name ? (
            <div className="mt-2 text-sm text-red-600">
              {formik.errors.name}
            </div>
          ) : null}
        </div>
        <div className="mt-3 col-span-4 sm:col-span-1">
          <label
            htmlFor="country"
            className="block text-sm font-medium text-gray-700"
          >
            Country *
          </label>
          <select
            id="country_id"
            name="country_id"
            autoComplete="country-name"
            className="bg-inputbg border border-inputBorder mt-1 block w-full rounded-md  py-2 px-3  focus:border-purplecolor-100 focus:outline-none sm:text-sm"
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.country_id}
          >
            <option value="-1">--Select Country --</option>
            {countrys?.data.map((country) => (
              <option key={country.id} value={country.id}>
                {country.country_name}
              </option>
            ))}
          </select>
          {formik.touched.country_id && formik.errors.country_id ? (
            <div className="mt-2 text-sm text-red-600">
              {formik.errors.country_id}
            </div>
          ) : null}
        </div>
        {/* <div className="space-y-1 pt-5">
          <h5 className="mb-3 text-sm font-normal tracking-tight text-gray-900">
            Description *
          </h5>
          <label htmlFor="description" className="sr-only">
            Description
          </label>
          <textarea
            rows={4}
            name="description"
            id="description"
            className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
            // defaultValue={''}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            value={formik.values.description}
          />
          {formik.touched.description && formik.errors.description ? (
            <div className="mt-2 text-sm text-red-600">
              {formik.errors.description}
            </div>
          ) : null}
        </div> */}
        <div className="flex flex-shrink-0 justify-end py-4">
          <button
            type="button"
            className=" rounded-3xl border border-gray-300 bg-white py-3 px-8 mr-3 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
            onClick={onClose}
          >
            Cancel
          </button>
          {isLoading ? (
            <button
              type="submit"
              disabled
              className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
            >
              <svg
                role="status"
                className="inline mr-3 w-4 h-4 text-white animate-spin"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="#E5E7EB"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentColor"
                />
              </svg>
              Loading...
            </button>
          ) : (
            <button
              disabled={!(formik.dirty && formik.isValid)}
              type="submit"
              className="inline-flex justify-center rounded-3xl border border-transparent bg-violet-900 py-3 px-8 text-sm font-medium text-white shadow-sm hover:bg-violet-700 disabled:bg-violet-400 focus:outline-none"
            >
              Save
            </button>
          )}
        </div>
      </form>
    </>
  );
};

export default AddLocation;
